import {VuexModule, Module, Action, Mutation, getModule} from 'vuex-module-decorators'
import {removeToken} from '@/utils/cookies'
import {AppModule} from './app'
import store from '@/store'
import api from '@/api/index'
import router, {asyncRouter} from '@/router/index'

import {getOu, setOu} from '@/utils/cookies'

import {RouteConfig} from 'vue-router'
import {PermissionModule} from './permission'
import {UserLoginInfoDto, OrganizationUnitDto, AuthenticateResultModel} from '@/api/appService'
import {setStore, getStore} from '@/utils/storage'

// export interface IUserState {
//   token: string
//   name: string
//   avatar: string
//   introduction: string
//   roles: string[]
//   user: any
// }

function getPermissionDefinitions() {
  return api.permissionDefinition.getAll({sorting: 'displayOrder asc,id asc', maxResultCount: 65536});
}

let storage = JSON.parse(window.localStorage.getItem('user') || window.sessionStorage.getItem('user') || '{}') as any

@Module({dynamic: true, store, name: 'user'})
class User extends VuexModule {

  public token = storage.token
  public name = storage.name
  public avatar = storage.avatar
  public introduction = storage.introduction;
  public tenantId?: number = storage.tenantId || 2
  public roles: string[] = storage.roles || []
  public permissions: string[] = storage.permissions || []

  public ou?: OrganizationUnitDto = getStore<OrganizationUnitDto>("currentOrganization") || {
    displayName: "深圳市慈善会",
    logoImageUrl: '/img/logo-square-2.png',
  };

  get ouId() {
    let ouid = this.ou?.id ?? getOu();
    return ouid;
  }

  get getOU() {
    return this.ou;
  }

  public user: UserLoginInfoDto = (storage.user as UserLoginInfoDto) || {
    id: -1,
    name: undefined,
    surname: undefined,
    userName: undefined,
    emailAddress: undefined
  };

  get getToken() {
    return this.token;
  }


  get getRoles() {
    return this.roles;
  }


  get getIsAdmin() {
    return this.roles.find(x => x === "Admin") ? true : false;
  }


  get getAvatar() {
    return '';
  }

  get getName() {
    return this.user.name;
  }

  get getFullName() {
    // this.user.surname as string +
    return this.user?.name as string;
  }

  get getPermissions() {
    return this.permissions;
  }

  @Mutation
  private SET_TOKEN(token: string) {
    console.log('SET_TOKEN');
    this.token = token
    User.serialize({token})
  }

  @Mutation
  private SET_ROLES(roles: string[] | string) {
    console.log('SET_ROLES');
    if (Array.isArray(roles))
      this.roles = [...roles]
    else
      this.roles = [roles];

    User.serialize({roles})

  }


  @Mutation
  private SET_PERMISSIONS(permissions: string[]) {
    this.permissions = permissions;
    User.serialize({permissions:this.permissions})
  }

  @Mutation
  private SET_USER(user: any) {
    console.log('SET_USER');
    this.user = user
    User.serialize({user})
  }

  @Mutation
  private SET_OU(ou?: OrganizationUnitDto) {
    this.ou = ou
    setStore("currentOrganization", ou);
    setOu(ou?.id?.toString() ?? '');
    User.serialize(ou)
  }

  private static serialize(params:any){
    storage = {...storage,...params}
    window.localStorage.setItem('user',JSON.stringify(storage))
    window.sessionStorage.setItem('user',JSON.stringify(storage))
  }


  @Action
  public SetToken(token: string) {
    this.SET_TOKEN(token)
  }

  @Action
  public SetRoles(roles: string[] | string) {
    if (Array.isArray(roles))
      this.SET_ROLES(roles)
    else
      this.SET_ROLES([roles])
  }

  @Action
  public Logout() {
    this.SET_OU(undefined);
    this.SET_TOKEN('');
    this.SET_PERMISSIONS([]);
    this.SET_ROLES([]);
    this.SET_USER(undefined);
  }

  @Action
  public async login(loginResult: AuthenticateResultModel) {
    this.SET_TOKEN(loginResult.accessToken!)
    await getPermissionDefinitions().then(permissionResponse => {
      api.session.getCurrentLoginInformations().then((res) => {
        //console.log(res);
        this.SET_USER(res.user)
        AppModule.SetTenant(res.tenant!);


        if (res.permissions) {
          this.SET_PERMISSIONS(res.permissions)
        }  else {
          this.SET_PERMISSIONS([])
        }


        let organizationUnitType = "";
        if (res.organizationUnit) {
          organizationUnitType = res.organizationUnit!.organizationType! + '';
          this.SET_OU(res.organizationUnit)
        } else {
          if (this.getIsAdmin) {
            organizationUnitType = "Foundation"
          }
        }
        PermissionModule.GenerateMenus({
          permissions: res.permissions!,
          roles: [],
          type: organizationUnitType,
          permissionDefinitions: permissionResponse.items!
        });

      });
    });

  }


  @Action
  public ResetToken() {
    removeToken()
    this.SET_TOKEN('')
    this.SET_ROLES([])
  }

  @Action
  public GetUserInfo(roles: string[]) {
    getPermissionDefinitions().then(permissionResponse => {
      api.session.getCurrentLoginInformations().then((res) => {
        //console.log(res);
        store.commit('SET_USER', res.user);

        AppModule.SetTenant(res.tenant!);


        if (res.permissions) {
          store.commit('SET_PERMISSIONS', res.permissions);
        }


        let organizationUnitType = "";
        if (res.organizationUnit) {
          organizationUnitType = res.organizationUnit!.organizationType! + '';
          store.commit('SET_OU', res.organizationUnit)
        } else {
          if (this.getIsAdmin) {
            organizationUnitType = "Foundation"
          }
        }
        PermissionModule.GenerateMenus({
          permissions: res.permissions!,
          roles: roles,
          type: organizationUnitType,
          permissionDefinitions: permissionResponse.items!
        });

      });
    });


  }

  @Action
  public Set_Ou(ou: OrganizationUnitDto) {
    this.SET_OU(ou);
    setStore("currentOrganization", ou);
    getPermissionDefinitions().then(permissionResponse => {
      PermissionModule.GenerateMenus({
        permissions: this.permissions!,
        roles: this.roles,
        type: ou.organizationType! + '',
        permissionDefinitions: permissionResponse.items!
      });
    });


  }


}


export const UserModule = getModule(User)
